



















import { Component, Vue } from 'vue-property-decorator'
import Scheduler from './reports-component/Scheduler.vue'
import DownloadCsv from './reports-component/DownloadCsv.vue'
import ReportGenerator from './reports-component/ReportGenerator.vue'
import StatementGeneratorLog from './reports-component/StatementGeneratorLog.vue'

@Component({
  components: {
    Scheduler,
    DownloadCsv,
    ReportGenerator,
    StatementGeneratorLog
  }
})
export default class Reports extends Vue {
}
